<div class="icon-status-container" [class.icon-right]="iconRight">
	@if (!iconRight) {
		<lucide-icon 
			[name]="iconName" 
			[size]="24"
			[class]="'status-icon status-' + status">
		</lucide-icon>
		<span class="status-label">{{ displayLabel }}</span>
	} @else {
		<span class="status-label">{{ displayLabel }}</span>
		<lucide-icon 
			[name]="iconName" 
			[size]="24"
			[class]="'status-icon status-' + status">
		</lucide-icon>
	}
</div>
